<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-50 -50 100 100">
    <path class="fill-current" :d="actualShape"></path>
  </svg>
</template>
<script setup lang="ts">
  import { computed } from 'vue'
  import { shapePaths, type Shape } from './shape-paths'

  const props = defineProps<{
    shape: Shape
  }>()

  const actualShape = computed(() => {
    return shapePaths[props.shape]
  })
</script>
